import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';

import { TCustomAxiosError } from '@/services/api';
import {
  TVerifyContentCreatorApplicationBody,
  verifyContentCreatorApplicationPost,
} from '@/services/api/requests/contentCreatorApplications';

import useToast from '../useToast';

const useVerifyContentCreatorApplication = (onSuccessCallback: (success: boolean) => void) => {
  const toast = useToast();

  const [errorMessage, setErrorMessage] = useState('');
  const fallbackErrorMessage = 'An error occurred while verifying your email. Please try again.';

  const { data, isError, isPending, mutate } = useMutation<
    { success: boolean },
    TCustomAxiosError,
    TVerifyContentCreatorApplicationBody
  >({
    mutationFn: async (data: TVerifyContentCreatorApplicationBody) => {
      return verifyContentCreatorApplicationPost(data);
    },
    onSuccess: (data: { success: boolean }) => {
      setErrorMessage(data.success ? '' : fallbackErrorMessage);
      onSuccessCallback?.(data.success);
    },
    onError: (error: TCustomAxiosError) => {
      const finalErrorMessage = error?.errors?.[0]?.message || fallbackErrorMessage;
      setErrorMessage(finalErrorMessage);
      onSuccessCallback?.(false);
      toast({
        status: 'error',
        title: 'Verification Failed',
        description: finalErrorMessage,
      });
    },
  });

  return { isError, isPending, mutate, success: data?.success, errorMessage };
};

export default useVerifyContentCreatorApplication;
